import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { isFollowing } from "../../api/listings";
import useUser from "../user/useUser";
import { setIsFollowingCoach } from "../../redux/pages/trainingPlanSlice";
import {
  FollowingPages,
  IUseFollowingCoach,
} from "../../interfaces/hooks/IUseFollowingCoach";
import { setIsFollowing } from "../../redux/pages/specialistSlice";

export const useFollowingCoach = ({ page }: IUseFollowingCoach) => {
  const userRedux = useSelector((state: RootState) => state.user.value);
  const { user } = useUser();

  const coachFromListingRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData?.user
  );
  const coachRedux = useSelector(
    (state: RootState) => state.specialist.coachData
  );
  const dispatch = useDispatch();
  const isFromSpecialistPage = page == FollowingPages.COACH;
  useEffect(() => {
    userRedux.loggedUser &&
      isFollowing(
        isFromSpecialistPage ? coachRedux.id : coachFromListingRedux.id,
        user.token
      )
        .then((data) => {
          isFromSpecialistPage
            ? dispatch(setIsFollowing(data))
            : dispatch(setIsFollowingCoach(data));
        })
        .catch((error: Error) => {
          console.error(error);
        });
  }, [
    userRedux,
    coachRedux?.id,
    user?.token,
    dispatch,
    isFromSpecialistPage,
    coachFromListingRedux?.id,
  ]);
};
